function showAllSearchedItems(filterItems) {
    for (const filter of filterItems) {
        filter.style.display = "";
    }
}

export function initSearchItems(query) {
    for (const input of query) {
        const wrapperClass = input.dataset.wrapper;
        const itemClass = input.dataset.item;
        const wrapper = input.closest("." + wrapperClass);
        if (wrapper) {
            const filterItems = wrapper.querySelectorAll("." + itemClass);

            if (filterItems) {
                input.addEventListener('keyup', () => {
                    const searchedValue = input.value.toUpperCase();

                    if (searchedValue === "" || searchedValue === null || searchedValue === undefined) {
                        showAllSearchedItems(filterItems);
                        return false;
                    }
                    for (const item of filterItems) {
                        const filterValues = item.textContent || item.innerText;

                        if (filterValues.toUpperCase().indexOf(searchedValue) > -1) {
                            item.style.display = "";
                        } else {
                            item.style.display = "none";
                        }
                    }
                });
            }
        }
    }
}